import { Icon } from "@iconify/react/dist/iconify.js";
import React, { useRef } from "react";
import Flatpickr from "react-flatpickr";

function SOFilters({
  date, // The selected date range (start & end)
  setDate, // Function to update the selected date range
  setSearchSOTitle,
  searchSOTitle,
  onClearFilters, // Function to handle the clear action
}) {
  const flatpickrRef = useRef();

  return (
    <div className="fp-filters-container">
      <div className="d-flex flex-1 gap-2">
        {/* Search bar */}
        <div className="fp-filters-search d-flex align-items-center gap-2">
          <Icon icon="pajamas:search" fontSize={20} />
          <input
            type="text"
            placeholder="Search here"
            value={searchSOTitle}
            onChange={(e) => setSearchSOTitle(e.target.value)}
            className="fp-filters-search-input"
          />
        </div>

        {/* Date range selector */}
        <div className="fp-filters-date d-flex align-items-center gap-2">
          <div className="dod-schedule-date-container position-relative">
            <span
              className="dod-schedule-calender-icon me-2"
              onClick={() => flatpickrRef.current.flatpickr.open()}
            >
              <Icon icon="uis:calender" fontSize={20} />
            </span>
            <Flatpickr
              className="dod-schedule-flatpickr-container"
              name="dateRange"
              placeholder="Select Date Range"
              value={date}
              options={{
                dateFormat: "M j, Y",
                static: true,
                disableMobile: true,
                mode: "range", // Enable range selection
              }}
              ref={flatpickrRef}
              onChange={([startDate, endDate]) => {
                const selectedStartDate = startDate
                  ? new Date(startDate)
                  : null;
                const selectedEndDate = endDate ? new Date(endDate) : null;

                // Convert to UTC (if needed)
                if (selectedStartDate) {
                  selectedStartDate.setMinutes(
                    selectedStartDate.getMinutes() -
                      selectedStartDate.getTimezoneOffset()
                  );
                }

                if (selectedEndDate) {
                  selectedEndDate.setMinutes(
                    selectedEndDate.getMinutes() -
                      selectedEndDate.getTimezoneOffset()
                  );
                }

                // Update the selected date range
                setDate([selectedStartDate, selectedEndDate]);
              }}
            />
          </div>
        </div>
        {/* Clear filters button */}
        <button
          className="border-0 d-flex p-0 m-0 align-items-center justify-content-center bg-white clear-filters-btn"
          onClick={onClearFilters}
        >
          {/* add cross icon from react icons */}
          <Icon icon="ic:twotone-close" fontSize={20} /> Clear Filters
        </button>
      </div>
    </div>
  );
}

export default SOFilters;
